import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { num_word } from 'vpl.tas';


export const ProektirovanieSections = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){


    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<div v-if="this.struct[this.structKey].componentData.ITEMS" style="display: contents;">
    <section class="section section--first">
        <div class="container">
            <div class="services">
                <div class="services__text content" v-html="this.struct[this.structKey].componentData.TEXT">
                </div>
                <div class="services__img">
                    <picture>
                        <source type="image/avif" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/instrument3.avif'">
                        <source type="image/webp" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/instrument3.webp'">
                        <img :src="this.SITE_TEMPLATE_PATH + '/img/content/instrument3.png'" alt="" title="" width="1000" height="667" fetchpriority="high">
                    </picture>
                </div>
            </div>
        </div>
    </section>
    <section class="section section--gray2">
        <div class="container">
            <div class="instrumentation__list instrumentation__list--compact" style="display: grid;">
                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="header__bottom-nav-dropdown-block">
                    <a :href="item.LINK" class="header__bottom-nav-dropdown-block-title">
                        <div v-if="item.ICON !== false" class="header__bottom-nav-dropdown-block-title-icon">
                            <img :src="item.ICON" :alt="item.NAME" :title="item.NAME">
                            <img :src="(item.ICON_H !== false ? item.ICON_H : item.ICON)" class="hover" :alt="item.NAME" :title="item.NAME">
                        </div>
                        {{item.NAME}}
                    </a>
                    <div class="header__bottom-nav-dropdown-block-title-desc">
                        {{item.TEXT}}
                    </div>
                    <ul v-if="item.ITEMS && item.ITEMS.length" class="header__bottom-nav-dropdown-block-list">
                        <li v-for="subItem in item.ITEMS">
                            <a :href="subItem.LINK">{{subItem.NAME}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</div>
    `
}